import React, { useState } from 'react'
import { useText } from './TextContext';


interface SaveToastContext {
    startSaving: () => number
    markSaved: (id?: number) => void
    stopSaving: () => void
}

interface Props {
    children: any
}

const saveToastContext = React.createContext<SaveToastContext>({
    startSaving: () => 0,
    markSaved: () => { },
    stopSaving: () => { }
});

export const useSaveToast = () => React.useContext(saveToastContext);

let currentSaveId = 0;
const TIMEOUT = 3000;

export default function SaveToastContextProvider({ children }: Props) {
    const text = useText();
    const [currentState, setCurrentState] = useState({ saving: false, saved: false });

    const label = currentState.saving ? text.saving : `${text.saved} ✓`;

    const startSaving = () => {
        setCurrentState({ saving: true, saved: false })
        return ++currentSaveId;
    };

    const stopSaving = () => {
        setCurrentState({ saving: false, saved: false })
    }

    const markSaved = async (myId?: number) => {
        if (myId && myId !== currentSaveId) {
            return;
        }
        setCurrentState({ saving: false, saved: true })

        await new Promise((resolve) => setTimeout(resolve, TIMEOUT));
        if (myId && myId !== currentSaveId) {
            return;
        }

        setCurrentState({ saving: false, saved: false })
    }

    const isVisible = currentState.saving || currentState.saved;

    return (
        <saveToastContext.Provider value={{ startSaving, markSaved, stopSaving }}>
            {children}
            <div className={`saving-wrapper ${isVisible ? 'show' : ''}`}>
                <div className={`px-5 py-2 rounded-top bg-secondary text-light`}>
                    {label}
                </div>
            </div>
        </saveToastContext.Provider>
    )
}